import { render, staticRenderFns } from "./v-layout.vue?vue&type=template&id=2c2b078c&scoped=true&"
import script from "./v-layout.vue?vue&type=script&lang=js&"
export * from "./v-layout.vue?vue&type=script&lang=js&"
import style0 from "./v-layout.vue?vue&type=style&index=0&id=2c2b078c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2b078c",
  null
  
)

export default component.exports